import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = ['rowTemplate', 'formRows']
    static values = { rowSelector: String }

    addRow(event) {
        event.preventDefault()

        const identifier = new Date().getTime()
        const requestedTemplateName = event.currentTarget.dataset.templateName

        let rowTemplate = null

        if (requestedTemplateName) {
            rowTemplate = this.rowTemplateTargets.find(target => target.dataset.templateName == requestedTemplateName)
        } else {
            rowTemplate = this.rowTemplateTarget
        }

        const newRowContent = rowTemplate.innerHTML.replace(/NEW_RECORD/g, identifier)
        this.formRowsTarget.insertAdjacentHTML('beforeend', newRowContent)
    }

    deleteRow(event) {
        event.preventDefault()

        const rowSelector = this.rowSelectorValue || '.form-row'
        const row = event.currentTarget.closest(rowSelector)
        const destroyInput = row.querySelector('.destroy')

        if (destroyInput) {
            row.querySelector('.destroy').value = '1'
        }

        row.style.display = 'none'
    }
}
